export default 'notices';
